<template>
  <div class="createPostBtnWrapper">
    <v-row id="content">
      <v-col cols="12" :md="8" :sm="7">
        <PageTitle :title="$gettext('Last Vlog') + ' ' + course.name" />
        <LanguageCard
          class="mb-6"
          @setLanguage="setLanguage"
          :total="total"
          :type="[POST_TYPE_VLOG]"
        />
        <PostList
          ref="postList"
          :key="languageDefault"
          :action="'post/getGolfVlog'"
          :language="languageDefault"
          :postType="POST_TYPE_VLOG"
          :courseId="course.id"
          isGolfCourse
          :typeShowText="{name: course.name, type: 'course', vlog: 'Vlogs'}"
        />
      </v-col>
      <v-col cols="12" :md="4" :sm="5">
        <DrawerRight />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LanguageCard from "@/components/Card/LanguageCard";
import DrawerRight from "@/components/DrawerRight";
import PageTitle from "@/components/PageTitle";
import PostList from "@/components/Post/PostList";
export default {
  name: "CoursesVlog",
  metaInfo() {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [
        {
          name: "description",
          content: this.metaDescription,
          vmid: 'description'
        },
      ],
    };
  },
  props: {
    isCourseAdmin: { type: Boolean, default: false },
  },
  components: {
    DrawerRight,
    PageTitle,
    LanguageCard,
    PostList,
  },
  data() {
    return {
      listVlog: [],
      dialogDetail: false,
      postDetail: null,
      currentPage: null,
      totalPages: null,
      endData: false,
      postData: {},
      total: 0,
    };
  },

  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
    languageDefault: {
      get() {
        return this.$store.state.post.languageDefaultVlog;
      },
    },
    golfVlogLanguage() {
      return this.$store.state.post.golfVlogLanguage;
    },
    metaTitle() {
      return this.$gettextInterpolate(this.$gettext("%{courseName} - Golf Courses VLOG"), {
        courseName: this.course && this.course.name ? this.course.name : "",
      });
    },
    metaDescription() {
      const binder = {
          courseName: this.course && this.course.name ? this.course.name : "",
          countryName:
            this.course && this.course.country.name
              ? this.course.country.name
              : "",
      }
      const translated = this.$gettext("VLOG at %{courseName} golf courses  in %{countryName}, Discover %{courseName} VLOG of Golf courses. Check all the Golf courses VLOG at %{courseName}");
      return this.$gettextInterpolate(translated, binder);
    },
  },
  beforeDestroy() {
    let vm = this;
    //reset golf course detail
    vm.$store.commit("setCourseDetail", {});
  },
  methods: {
    setLanguage(list) {
      this.listVlog = list;
    },
  },
};
</script>
<style lang="scss">
.btn-action {
  position: absolute;
  right: 20px;
}
.v-dialog--scrollable::-webkit-scrollbar {
  width: 0 !important;
}
.v-dialog--scrollable {
  overflow: -moz-scrollbars-none;
}
.v-dialog--scrollable {
  -ms-overflow-style: none;
}
</style>